import { AdminBarberRepository } from "../../Repository";

export async function changeCommunication(
  communication: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.setCommunication(communication);
}
